import React from 'react';
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import {getGoalPercentage} from "./GoalProgressUtils";

function GoalTabLabel({ goals }) {
	const activeGoals = (goals ?? []).filter(g => !g.dateCompleted);

	if (activeGoals.length === 0) {
		return "Goals";
	}

	const bestPercentage = Math.max(...activeGoals.map(g => getGoalPercentage(g)));

	return <Box display="flex" alignItems="center" gap={0.75}>
		<span>Goals</span>
		<Box position="relative" display="inline-flex" sx={{ width: 20, height: 20 }}>
			<CircularProgress
				variant="determinate"
				value={100}
				size={20}
				thickness={4}
				sx={{ color: 'rgba(255,255,255,0.15)', position: 'absolute' }}
			/>
			<CircularProgress
				variant="determinate"
				value={bestPercentage}
				size={20}
				thickness={4}
				sx={{ color: bestPercentage >= 90 ? '#66bb6a' : 'rgba(255,255,255,0.7)' }}
			/>
			<Box
				position="absolute"
				top={0}
				left={0}
				right={0}
				bottom={0}
				display="flex"
				alignItems="center"
				justifyContent="center"
			>
				<Typography sx={{ fontSize: 8, color: 'rgba(255,255,255,0.9)', lineHeight: 1 }}>
					{activeGoals.length}
				</Typography>
			</Box>
		</Box>
	</Box>
}

export default GoalTabLabel;
